import {ApiSortsDerived} from '@/api/meta/odata';
import {createVersionedStorage} from './types';
import {boolToDisplay, fulltextToDisplay} from '@/util/store';
import Umbuchung, {ApiUmbuchung, UmbuchungFilters} from '@/model/Umbuchung';
import {getUmbuchungen} from '@/api/module/umbuchung';
import {ValueType} from '@/api/meta/filters';


const useUmbuchungsStore = createVersionedStorage<
  UmbuchungFilters, ApiSortsDerived<ApiUmbuchung>, Umbuchung[]
>('umbuchungen', {
  fetchFn: getUmbuchungen,
  defaultData: [],
  defaultFilters: {
    Fulltext$Fulltext: {
      words: [],
      fields: [
        {
          path: ['BelegNr'],
          valueType: ValueType.NumberStartsWith,
        },
        {
          path: ['Bediener'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['NiederlassungAbgehend', 'Name1'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['NiederlassungEingehend', 'Name1'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['LKW', 'KFZKennzeichen'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['LKW', 'Bezeichnung'],
          valueType: ValueType.StringContains,
        },
      ],
    },
    Erledigt: false,
  },
  defaultSorts: [],
  formatter: {
    'Fulltext$Fulltext': fulltextToDisplay,
    'Erledigt': boolToDisplay('Ja', 'Nein', 'Erledigt'),
  },
});

export default useUmbuchungsStore;
